

/** Which tab of ArtefactDetailModal to land on. Exported at module scope because ProvidersList
 *  (the table) needs it too: the row's Policies button opens straight to that tab now that
 *  policies live inside the dossier instead of a modal of their own. */
export type ArtefactTab = 'insight' | 'versions' | 'policies' | 'actions'

export const ARTEFACT_TABS: { key: ArtefactTab; label: string }[] = [
  { key: 'insight', label: 'Insight' },
  { key: 'versions', label: 'Versions' },
  { key: 'policies', label: 'Policies' },
  { key: 'actions', label: 'Actions' },
]

